"use client";

import { ILeanProductTile } from "@faire/web-api/indigofair/data/ILeanProductTile";
import React, { ReactNode, useMemo } from "react";

import { ProductTileContext } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/common";

export const ProductTileContextProvider = ({
  brandToken,
  brand,
  children,
}: {
  brandToken: string | undefined;
  brand: ILeanProductTile.IBrand | undefined; // Only used for LoggedOut case
  children: ReactNode;
}) => {
  const contextValue = useMemo(
    () => ({ recordAdImpression: true, brandToken, brand }),
    [brand, brandToken]
  );
  return (
    <ProductTileContext.Provider value={contextValue}>
      {children}
    </ProductTileContext.Provider>
  );
};
